<template>
	<Multiselect
		v-model="value"
		:options="props.options"
		:track-by="props.trackBy"
		:label="props.label"
		:placeholder="props.placeholder"
		:show-labels="props.showLabels"
		:allow-empty="props.allowEmpty"
		:multiple="props.multiple"
		:taggable="props.taggable"
		:searchable="props.searchable"
		:option-height="props.optionHeight"
		:tag-placeholder="props.tagPlaceholder"
		@tag="val => emit('tag', val)"
	>
		<template #selection="attrs">
			<slot v-if="$slots['selection']" name="selection" v-bind="attrs" />
		</template>

		<template #singleLabel="attrs">
			<slot v-if="$slots['singleLabel']" name="singleLabel" v-bind="attrs" />
		</template>

		<template #option="attrs">
			<slot v-if="$slots['option']" name="option" v-bind="attrs" />
		</template>

		<template #noResult>
			<slot v-if="$slots['noResult']" name="noResult" />
			<template v-else>
				{{ $t('placeholder.nothingWasFound') }}
			</template>
		</template>
	</Multiselect>
</template>

<script>
export default {
	name: 'UICombobox',
}
</script>

<script setup>
import { computed } from 'vue'
import Multiselect from 'vue-multiselect'

const props = defineProps({
	modelValue: {
		type: [Object, Array, String, Number, null],
		default: () => [],
		required: true,
	},
	options: { type: [Array, Object], required: true },
	trackBy: { type: String, default: '' },
	label: { type: String, default: '' },
	optionHeight: { type: Number, default: 40 },
	placeholder: { type: String, default: 'Select option' },
	showLabels: { type: Boolean, default: false },
	allowEmpty: { type: Boolean, default: true },
	multiple: { type: Boolean, default: false },
	searchable: { type: Boolean, default: true },
	taggable: { type: Boolean, default: false },
	preselectFirst: { type: Boolean, default: false },
	tagPlaceholder: { type: String, default: 'Press enter to create a tag' },
})

const emit = defineEmits(['update:model-value', 'tag'])

const value = computed({
	get: () => props.modelValue,
	set: value => emit('update:model-value', value),
})
</script>
